import ACTIONS_TYPES from '../../constants/types';
import { UserActionTypes } from '../actions/userActions';

export interface IUserState {
  email: string;
  autoRefreshTimeInSecs: string;
  firstName: string;
  lastLoginAt: string;
  lastName: string;
  nickname: string;
  prefLanguage: string;
  refreshToken: string;
  token: string;
  userId: string;
  dateOfBirth: string;
  mobileNumber?:string;
  countryOfBirth?:string;
  disabilityCategoryCode?:string;
  documentUrls?:string[];
  gender?:string;
  placeOfBirth?:string;
  fiscalCode?:string;
  idDocuments?:string[];
}

const initialState: IUserState = {
  email: '',
  autoRefreshTimeInSecs: '',
  firstName: '',
  lastLoginAt: '',
  lastName: '',
  nickname: '',
  prefLanguage: '',
  refreshToken: '',
  token: '',
  userId: '',
  dateOfBirth: '',
  mobileNumber: '',
  countryOfBirth:'',
  disabilityCategoryCode:'',
  documentUrls:[],
  gender:'',
  placeOfBirth:'',
  fiscalCode:'',
  idDocuments:[]
};

export default function (state = initialState, action: UserActionTypes) {
  switch (action.type) {
    case ACTIONS_TYPES.SET_ACCOUNT_DATA: {
      const user = action.payload as IUserState;
      return {
        ...state,
        autoRefreshTimeInSecs: user.autoRefreshTimeInSecs,
        countryOfBirth: user.countryOfBirth,
        dateOfBirth: user.dateOfBirth?? null,
        firstName: user.firstName,
        lastLoginAt: user.lastLoginAt,
        lastName: user.lastName,
        nickname: user.nickname,
        mobileNumber: user.mobileNumber,
        prefLanguage: user.prefLanguage,
        refreshToken: user.refreshToken,
        token: user.token,
        userId: user.userId,
        email: user.email,
        disabilityCategoryCode: user.disabilityCategoryCode,
        documentUrls: user.documentUrls,
        gender: user.gender,
        placeOfBirth: user.placeOfBirth,
        fiscalCode: user.fiscalCode,
        idDocuments: user.idDocuments,
      };
    }

    case ACTIONS_TYPES.LOGOUT: {
      return { ...initialState };
    }

    default:
      return state;
  }
}
